<template>
  <v-navigation-drawer
    @input="$emit('openDrawer', $event)"
    :disable-route-watcher="false"
    :value="drawer"
    width="300"
    clipped
    temporary
    right
    app
  >

    <v-list dense v-if="listMarkets" class="mt-15">
      <div class="d-flex justify-center pa-4">
        <SearchBox
          v-if="currentRoute && currentRoute !== 'Home'"
        />
      </div>
      <v-subheader class="text-h6">
        <router-link :to="{ name: 'Groups' }">
          {{ $t('menu.markets.text') }}
        </router-link>
      </v-subheader>
      <v-list-item-group>
        <v-list-item
          class="py-2"
          v-for="(market) in listMarkets"
          :key="market.key"
          exact
          href
          :to="{
            name: 'SingleMarkets',
            params: { market: market.key.toLowerCase() }}
          "
        >
          <market-icons :spacing="false" :items="[market.key]" />
          <span class="ml-3">
            <span class="font-weight-bold" v-if="market.key !== 'null'">
              {{ market[`name_${$i18n.locale.split('-')[0]}`] }}
            </span>
            <small class="d-block subtitle-1 font-weight-light">
              {{ $tc('theme.documentCount', [market.count]) }}
            </small>
          <span>
        </v-list-item>

      </v-list-item-group>
      <v-subheader class="text-h6">
        {{ $tc('theme.availableLanguage', langs.length) }}
      </v-subheader>
      <v-list-item-group>
        <v-list-item
          v-for="lang in langs"
          @click="onChangeLanguage(lang.key)"
          :key="lang.key"
        >
          <v-list-item-title class="d-flex align-center">
            <flag
              :iso="lang.flag"
              :squared="false"
            /> <span class="ml-2">{{ lang.label }}</span>
          </v-list-item-title>
        </v-list-item>

      </v-list-item-group>
    </v-list>

  </v-navigation-drawer>
</template>
<script>
import Mixins from '@/core/mixins'
import MarketIcons from '@/components/file/Markets'
import SearchBox from '@/components/layout/SearchBox'
export default {
  name: "Banner",
  data () {
    return {
      langs: [
        {
          key: 'en',
          flag: 'gb',
          label: 'English'
        },
        {
          key: 'fr',
          flag: 'fr',
          label: 'Français'
        },
      ]
    }
  },
  mixins: [ Mixins ],
  components: {
    SearchBox,
    MarketIcons
  },
  props: {
    currentRoute: String,
    drawer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dataFormat () {
      const lang = this.$i18n.locale.split('-')[0]
      return lang === 'en' ? 'gb' : lang
    },

    listMarkets () {
      const markets = this.$store.getters["home/termsType"]('markets')
      return markets
    },

    navigation () {
      return [
        // {
        //   link: 'Home',
        //   text: this.$t('menu.home.text'),
        //   title: this.$t('menu.home.title'),
        //   active: false
        // },,
        {
          link: 'MediaLibrary',
          text: this.$t('menu.mediaLibrary.text'),
          title: this.$t('menu.mediaLibrary.title'),
          active: false
        },
        {
          link: 'Groups',
          text: this.$t('menu.markets.text'),
          title: this.$t('menu.markets.title'),
          active: false
        }
      ]
    }
  },
  methods: {
    onChangeLanguage (newLang) {
      this.$root._i18n._vm.locale = newLang
    }
  }
}
</script>
